const COLORS_EVEN = [
  '#137E87',
  '#99A4E4',
  '#4555AB',
  '#CB2809',
  '#DFC798',
  '#CECECE',
  '#9FD1D6',
];

// const COLORS_ODD = [
//   '#a593cd',
//   '#f78f48',
//   '#79287c',
//   '#0e3151',
//   '#057ebd',
//   '#7dc242',
// ];

const colors = {
  odd: COLORS_EVEN,
  even: COLORS_EVEN,
};

export default colors;
